import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["heroForm", "headerForm"];
  static values = {
    threshold: { type: Number, default: 150 },
  };

  connect() {
    this.ticking = false;
    this._scrollHandler = this.handleScroll.bind(this);
    this._dropdownClosedHandler = this.onDropdownClosed.bind(this);
    window.addEventListener("scroll", this._scrollHandler, { passive: true });
    window.addEventListener(
      "activity-selector:closed",
      this._dropdownClosedHandler,
    );
    this.updateFormVisibility();
  }

  disconnect() {
    if (this._scrollHandler) {
      window.removeEventListener("scroll", this._scrollHandler);
    }
    if (this._dropdownClosedHandler) {
      window.removeEventListener(
        "activity-selector:closed",
        this._dropdownClosedHandler,
      );
    }
  }

  onDropdownClosed() {
    // Force update after dropdown closes
    this.updateFormVisibility();
  }

  handleScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.updateFormVisibility();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  updateFormVisibility() {
    // Don't transition if activity dropdown is open
    const activityDropdownOpen = document.querySelector(
      '[data-activity-selector-target="expanded"]:not(.hidden)',
    );
    if (activityDropdownOpen) return;

    const scrollY = window.scrollY;

    if (scrollY > this.thresholdValue) {
      this.hideHeroForm();
      this.showHeaderForm();
    } else {
      this.showHeroForm();
      this.hideHeaderForm();
    }
  }

  hideHeroForm() {
    if (this.hasHeroFormTarget) {
      this.heroFormTarget.classList.remove("opacity-100", "scale-100");
      this.heroFormTarget.classList.add(
        "opacity-0",
        "scale-95",
        "pointer-events-none",
      );
    }
  }

  showHeroForm() {
    if (this.hasHeroFormTarget) {
      this.heroFormTarget.classList.remove(
        "opacity-0",
        "scale-95",
        "pointer-events-none",
      );
      this.heroFormTarget.classList.add("opacity-100", "scale-100");
    }
  }

  hideHeaderForm() {
    if (this.hasHeaderFormTarget) {
      this.headerFormTarget.classList.add("!hidden");
      this.headerFormTarget.classList.remove("flex");
    }
  }

  showHeaderForm() {
    if (this.hasHeaderFormTarget) {
      this.headerFormTarget.classList.remove("!hidden");
      this.headerFormTarget.classList.add("flex");
    }
  }
}
